// v-click-outside="handler" — calls handler when a click lands outside the element.
// A trigger that uses @click.stop keeps other open dropdowns untouched.
export default {
    bind(el, binding) {
        el.__clickOutsideHandler__ = binding.value;
        el.__clickOutside__ = e => {
            if (!el.contains(e.target) && el.__clickOutsideHandler__) el.__clickOutsideHandler__(e);
        };
        document.addEventListener('click', el.__clickOutside__);
    },
    componentUpdated(el, binding) {
        el.__clickOutsideHandler__ = binding.value;
    },
    unbind(el) {
        document.removeEventListener('click', el.__clickOutside__);
        delete el.__clickOutside__;
        delete el.__clickOutsideHandler__;
    }
};
